import React from 'react';

import { Text } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';

import { SelectionsListItem } from './styled';
import { ProductProps } from './types';

interface SelectionsListProps {
  selections: ProductProps['selections'];
  id: string;
}

export const SelectionsList: React.FC<React.PropsWithChildren<SelectionsListProps>> = ({
  selections,
}) => {
  const sortedSelections = (selections ?? []).sort(
    (a, b) => (b.multiplier ?? 0) - (a.multiplier ?? 0)
  );
  const selectionsList =
    sortedSelections
      ?.map(s => s.name?.trim())
      .filter(Boolean)
      .join(', ')
      ?.replace(/\s+/g, ' ')
      .trim() ?? '';

  return selectionsList ? (
    <SelectionsListItem>
      <Text bold>{t('yourWay') + ' '}</Text>
      {selectionsList}
    </SelectionsListItem>
  ) : null;
};
